module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresat")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail adresata",
      "name": "send_to",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail adresata wiadomości"
    },
    model: {
      value: (_vm.message.send_to),
      callback: function($$v) {
        _vm.message.send_to = $$v
      },
      expression: "message.send_to"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Wiadomość ")]), _vm._v(" "), _c('p', [_c('ui-button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fill($event)
      }
    }
  }, [_vm._v("Wypełnij przykładową treścią")])], 1), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł wiadomości",
      "name": "title",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz tytuł wiadomości"
    },
    model: {
      value: (_vm.message.title),
      callback: function($$v) {
        _vm.message.title = $$v
      },
      expression: "message.title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść wiadomości (treść tekstowa)",
      "name": "text_body",
      "type": "text",
      "placeholder": "Wpisz treść tekstową tej wiadomości",
      "multi-line": "",
      "rows": 8,
      "help-text": "Wpisz treść tekstową bez znaczników html"
    },
    model: {
      value: (_vm.message.text_body),
      callback: function($$v) {
        _vm.message.text_body = $$v
      },
      expression: "message.text_body"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść wiadomości (treść html)",
      "name": "html_body",
      "type": "text",
      "placeholder": "Wpisz treść html tej wiadomości",
      "multi-line": "",
      "rows": 8,
      "help-text": "Wpisz treść html tej wiadomości"
    },
    model: {
      value: (_vm.message.html_body),
      callback: function($$v) {
        _vm.message.html_body = $$v
      },
      expression: "message.html_body"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Wyślij testową wiadomość")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d734b11a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/TestForm.vue
// module id = 286
// module chunks = 0